import React from "react";
import Post from "./Post";
import { PostProperties, resolvePost } from "./AllPost";
import { useLanguage } from "../../context/LanguageContext";
import { useUI } from "../../constants/i18n";

interface PostGridProps {
  posts: PostProperties[];
}

const PostGrid: React.FC<PostGridProps> = ({ posts }) => {
  const { lang } = useLanguage();
  const ui = useUI(lang);

  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-1 gap-4 mt-8">
        {posts.map((post) => {
          const resolved = resolvePost(post, lang);
          const buttonText =
            resolved.category === "Lost Gem" ? ui.listenHere : ui.readMore;
          return (
            <Post
              key={post.id}
              title={resolved.title}
              content={resolved.content}
              image={resolved.image}
              category={resolved.category}
              buttonText={buttonText}
              buttonUrl={resolved.buttonUrl}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PostGrid;
